// ============================================================
// POPUP MODAL ENUMS
// ============================================================

// TODO: we should use typscript's "enum" type instead of "const"
// -> this indicates the use and we don't have to copy the string 2 times

import { Country } from 'world-countries';
import {
    CountryCode,
    RegistrationCompanyData,
    RegistrationCompanyInputErrors,
    RegistrationPaymentData,
    RegistrationPaymentInputErrors,
    RegistrationUserData,
    RegistrationUserInputErrors,
    RegistrationVehicleData,
    RegistrationVehicleInputErrors,
    SupportedLocale,
} from 'types';

export enum FeatureKey {
    USER_MANAGEMENT = 'USER_MANAGEMENT',
    PARKD_CARDS = 'PARKD_CARDS',
    DRIVER_SETTINGS = 'DRIVER_SETTINGS'
}

export enum RegistrationFlowType {
    TRACK_AND_TRACE = 'TRACK_AND_TRACE',
    OEM = 'OEM'
}

export enum ModalEnum {
    BASIC_MESSAGE_MODAL = 'BASIC_MESSAGE_MODAL',
    CHOOSE_CONNECTION = 'CHOOSE_CONNECTION',
    DELETE_VEHICLE = 'DELETE_VEHICLE',
    DELETE_USER = 'DELETE_USER',
    INVITE_YOUR_DRIVERS = 'INVITE_YOUR_DRIVERS',
    EXPORT_HISTORY = 'EXPORT_HISTORY',
    THANK_YOU_FOR_FEEDBACK = 'THANK_YOU_FOR_FEEDBACK',
    THANK_YOU_FOR_CONNECTION_REQUEST = 'THANK_YOU_FOR_CONNECTION_REQUEST',
    SOMETHING_WENT_WRONG = 'SOMETHING_WENT_WRONG',
    SEND_MESSAGE_TO_SUPPORT = 'SEND_MESSAGE_TO_SUPPORT',
    SEND_FEEDBACK_TO_SUPPORT = 'SEND_FEEDBACK_TO_SUPPORT',
    SEND_BUG_TO_SUPPORT = 'SEND_BUG_TO_SUPPORT',
    INFO_MODAL = 'INFO_MODAL',
    INFO_MODAL_PARKING_MODE = 'INFO_MODAL_PARKING_MODE',
    IMPORT_LICENSE_PLATES_SUCCEEDED = 'IMPORT_LICENSE_PLATES_SUCCEEDED',
    CONFIRMATION_DIALOG = 'CONFIRMATION_DIALOG',
    CHANGE_PARKING_MODE = 'CHANGE_PARKING_MODE',
    EDIT_WORKING_HOURS_COMPANY = 'EDIT_WORKING_HOURS_COMPANY',
    EDIT_WORKING_HOURS_LICENSEPLATE = 'EDIT_WORKING_HOURS_LICENSEPLATE',
    EDIT_SESSION_NOTE = 'EDIT_SESSION_NOTE',
    EDIT_COST_CENTER = 'EDIT_COST_CENTER',
    EDIT_USER = 'EDIT_USER',
    MANAGE_TABLE_COLUMNS = 'MANAGE_TABLE_COLUMNS'
};

export const REGISTRATION_FLOW = {
    REGISTRATION_SCREEN_1_ABOUT_YOU: 'REGISTRATION_SCREEN_1_ABOUT_YOU',
    REGISTRATION_SCREEN_2_A_FEW_MORE_DETAILS: 'REGISTRATION_SCREEN_2_A_FEW_MORE_DETAILS',
    REGISTRATION_SCREEN_3_PAYMENT_METHOD: 'REGISTRATION_SCREEN_3_PAYMENT_METHOD',
    REGISTRATION_SCREEN_4_CARD_DETAILS: 'REGISTRATION_SCREEN_4_CARD_DETAILS',
    REGISTRATION_SCREEN_5_CREATING_ACCOUNT: 'REGISTRATION_SCREEN_5_CREATING_ACCOUNT',
};

export const SUPPORT_PHONE_NUMBER = {
    BE: '03 207 08 47',
    NL: '030 237 79 32'
}

export const PROPOSED_DB_ACTION_TYPE = {
    ADD: 'ADD',
    REPLACE: 'REPLACE',
};

export const VEHICLE_STATE = {
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED',
    BLOCKED: 'BLOCKED',
};

export const VEHICLE_PARKING_MODE = {
    MANUAL: 'MANUAL',
    MANUAL_SHARED: 'MANUAL_SHARED',
    SHARED: 'SHARED',
    SEMI_AUTOMATIC: 'SEMI_AUTOMATIC',
    AUTOMATIC: 'AUTOMATIC',
    AUTONOMOUS: 'AUTONOMOUS',
};

export const CLAIM_STATE = {
    CLAIMED: 'CLAIMED',
    UNCLAIMED: 'UNCLAIMED',
    UNCLAIMABLE: 'UNCLAIMABLE',
};

export enum LicensePlatePermission {
    ACTIVE_LP = 'ACTIVE_LP',
    BLOCKED_LP = 'BLOCKED_LP'
}

export const LICENSE_PLATES_IMPORT_STEP = {
    ENTER_LICENSE_PLATES_COMPONENT: 'ENTER_LICENSE_PLATES_COMPONENT',
    VALIDATE_LICENSE_PLATES_COMPONENT: 'VALIDATE_LICENSE_PLATES_COMPONENT',
    IMPORT_LICENSE_PLATES_COMPONENT: 'IMPORT_LICENSE_PLATES_COMPONENT',
};

export const VEHICLE_FILTER = Object.freeze({
    BLOCKED: 'blocked',
    UNCLAIMED: 'unclaimed',
    NO_LOCATION_UPDATES: 'nolocationupdates',
});

export const PAYMENT_METHODS = {
    MONTHLY_INVOICE: 'MONTHLY_INVOICE',
    CREDIT_CARD: 'CREDIT_CARD',
};

export const USER_LOCALES: SupportedLocale[] = ['en', 'nl', 'nl-BE', 'fr'];

export const COUNTRY_CODE = {
    BE: 'BE',
    NL: 'NL',
};

export const DEFAULT_USER_LOCALE: SupportedLocale = 'nl';

export const DEFAULT_COUNTRY_CODE: Country['cca2'] = 'NL';

export const preferredCountriesForTelephoneInput = ['nl', 'be'];
export const defaultCountryForTelephoneInput: CountryCode = 'NL';

export enum PARKING_SESSIONS_TAB {
    TAB_ACTIVE = 'TAB_ACTIVE',
    TAB_HISTORICAL = 'TAB_HISTORICAL',
    TAB_OFFSTREET = 'TAB_OFFSTREET'
}

export const registrationDefaultUserData: RegistrationUserData = {
    givenName: '',
    familyName: '',
    email: '',
    password: '',
    locale: 'en', // fallback
    checkboxAccepted: false,
    phone: '',
};

export const registrationDefaultVehicleData: RegistrationVehicleData = {
    vin: '',
    mileage: '',
    licensePlate: '',
    brand: '',
    model: '',
    year: 0,
    month: 0,
    countryCode: DEFAULT_COUNTRY_CODE,
};

export const registrationDefaultCompanyData: RegistrationCompanyData = {
    vat: '',
    name: '',
    address: { street: '', number: '', city: '', postalCode: '', countryCode: DEFAULT_COUNTRY_CODE },
    email: '',
};

export const registrationDefaultPaymentData: RegistrationPaymentData = {
    type: 'CREDIT_CARD',
    data: {
        cardNumber: '',
        expiry: '',
        cvc: '',
    },
};

export const registrationVehicleInputErrors: RegistrationVehicleInputErrors = {
    vin: null,
    mileage: null,
    licensePlate: null,
    brand: null,
    model: null,
    month: null,
    year: null,
};

export const registrationUserInputErrors: RegistrationUserInputErrors = {
    givenName: null,
    familyName: null,
    email: null,
    password: null,
    checkboxAccepted: null,
    phone: null,
};

export const registrationCompanyInputErrors: RegistrationCompanyInputErrors = {
    vat: null,
    name: null,
    address: { street: null, number: null, city: null, postalCode: null },
    email: null,
};

export const registrationPaymentInputErrors: RegistrationPaymentInputErrors = {
    cardNumber: null,
    expiry: null,
    cvc: null,
};


// reference: './sass/_variables.sass'
export enum ThemeColor {
    green = '#35D38C',
    red = '#D34B35'
}
